import { render } from "./wildlife-model.vue?vue&type=template&id=b35617e2&scoped=true"
import script from "./wildlife-model.vue?vue&type=script&lang=js"
export * from "./wildlife-model.vue?vue&type=script&lang=js"

import "./wildlife-model.vue?vue&type=style&index=0&id=b35617e2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b35617e2"]])

export default __exports__